import { render, staticRenderFns } from "./PerformanceAssignmentDetail.vue?vue&type=template&id=1b516b85&scoped=true&"
import script from "./PerformanceAssignmentDetail.vue?vue&type=script&lang=js&"
export * from "./PerformanceAssignmentDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b516b85",
  null
  
)

export default component.exports